import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
const SPARKLE_ICON_SVG_ENCODED = encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 210 197"><g opacity="0.18"><path fill="#DDFA88" d="M105 -7.32996C119.448 64.91 132.09 77.552 204.33 92C132.09 106.448 119.448 119.09 105 191.33C90.5519 119.09 77.9099 106.448 5.66992 92C77.9099 77.552 90.5519 64.91 105 -7.32996Z"/></g></svg>`);
export function SparkleIcon() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      position: "absolute",
      top: 0,
      left: "calc(50% - 50vw)",
      width: "100vw",
      height: "100%",
      overflow: "hidden",
      pointerEvents: "none",
      zIndex: -1
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: "relative",
      height: "100%",
      mx: "auto",
      maxWidth: "lg",
      width: {
        xs: "calc(100% - 2 * var(--padding-x))",
        md: "100%"
      },
      paddingX: {
        md: "var(--padding-x)"
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box aria-hidden={true} aria-label="Decorative sparkle" sx={t0}><Box sx={t1}><Box sx={{
          position: "absolute",
          top: {
            xs: "-80px",
            md: "50%"
          },
          right: {
            xs: "calc(var(--padding-x) * -1)",
            md: "calc(var(--padding-x) - 30px)"
          },
          transform: {
            xs: "translateX(35%)",
            md: "translateY(-60%)"
          },
          width: "200px",
          height: "200px",
          background: `url(data:image/svg+xml,${SPARKLE_ICON_SVG_ENCODED}) no-repeat center center`
        }} /></Box></Box>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}